/*************************************************/
/* Collapsed text                                */
/*************************************************/


export function collapsedText() {
    const collapsedTextElementSelector = ".collapsed-text__text.collapsed";
    const collapsedTextElementParentSelector = ".collapsed-text";
    const collapsedClass = "collapsed";
    const triggerElementSelector = ".collapsed-text__bottom";

    const init = function () {
        const collapsedTextTriggers = document.querySelectorAll(triggerElementSelector);
        collapsedTextTriggers.forEach(trigger => {
            trigger.addEventListener('click', e => {
                let bottomElement = e.target;
                if(!bottomElement.classList.contains(triggerElementSelector)) {
                    bottomElement = bottomElement.closest(triggerElementSelector);
                }
                const collapsedTextElement = bottomElement.closest(collapsedTextElementParentSelector).querySelector(collapsedTextElementSelector);
                console.log(collapsedTextElement.scrollHeight);
                collapsedTextElement.style.maxHeight = collapsedTextElement.scrollHeight + 'px';
                collapsedTextElement.classList.remove(collapsedClass);
                bottomElement.remove();
            });
        });
    };



    init();
}